module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Row', {
    staticClass: "store-item"
  }, _vm._l((_vm.store), function(item, index) {
    return _c('i-col', {
      key: index,
      staticClass: "store-list",
      class: {
        'clear': index === 3
      },
      attrs: {
        "lg": 8,
        "md": 8
      }
    }, [_c('h3', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.address))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.phone))]), _vm._v(" "), _c('p', {
      staticClass: "more"
    }, [_c('router-link', {
      staticClass: "text-primary",
      attrs: {
        "to": {
          name: 'Shop',
          query: {
            id: item.id
          }
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('search_store_more')) + " >")])], 1)])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ffe19dc","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Search/Common/StoreItem.vue
// module id = 797
// module chunks = 0